export default function AboutTestimonials() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-16">
          <div className="lg:w-3/5">
            <span className="text-xs font-medium text-foreground-500 tracking-widest">
              · 编辑寄语
            </span>
            <div className="mt-6">
              <p className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 leading-tight">
                &ldquo;让好故事
              </p>
              <p className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 leading-tight">
                被每一个
              </p>
              <p className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 leading-tight">
                读者看见&rdquo;
              </p>
            </div>
            <div className="mt-5 flex items-center gap-2">
              <span className="text-sm font-semibold text-foreground-900">
                陈明远
              </span>
              <span className="inline-flex items-center gap-1 text-xs text-accent-600">
                <i className="ri-verified-badge-fill" /> 主编
              </span>
            </div>
          </div>

          <div className="lg:w-2/5 flex justify-center">
            <div className="w-64 h-80 md:w-72 md:h-96 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20black%20and%20white%20portrait%20of%20a%20creative%20team%20member%2C%20editorial%20style%2C%20side%20profile%2C%20confident%20pose%2C%20clean%20white%20background%2C%20professional%20look%2C%20modern%20minimalist%20composition&width=600&height=800&seq=team-portrait-01&orientation=portrait"
                alt="178漫画网团队"
                title="178漫画网编辑团队"
                className="w-full h-full object-cover object-top grayscale"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}